import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import {  
  Typography,  
  CircularProgress,  
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  FormControl,
  InputLabel,
  MenuItem,  
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import BarChartStacked from '../charts/BarChartStacked'
import Cookies from 'js-cookie'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import AskReport from '../AskReport'
import PageHeader from '../PageHeader'

const StyledTableRow = styled(TableRow)(({theme}) => ({
  '&:last-child td, &:last-child th': {
    border: 0,
  }
}))

const OtbCounts = (props) => {  
  const { dark } = props
  const token = Cookies.get("token")
  const [hasData, setHasData] = useState(true)
  const [otbData, setOtbData] = useState(null)
  const [source, setSource] = useState(0)
  const [dataSourced, setDataSourced] = useState(null)
  const [defaultData, setDefaultData] = useState(null)
  const [metric, setMetric] = useState("location")
  const [otbTotal, setOtbTotal] = useState(null)  
  const [selectedLocation, setSelectedLocation] = useState(null)  

  const getOtbData = () => {
    const request = Promise.all([
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/otb/location?Source=1`, {headers: {token: token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/otb/location?Source=0`, {headers: {token: token}})
    ])

    request.then(([response, response2]) => Promise.all([response.json(), response2.json()]))
    .then(([data, data2]) => {            
      if(data.length > 0) {
        setOtbData(data)
        setOtbTotal(data2.map(({Data}) => Data.map(({Qty}) => Qty).reduce((a,b) => a + b, 0)).reduce((a,b) => a + b, 0))
        setDataSourced(data2)
        setDefaultData(data2)
      } else {
        setHasData(false)
      }
    })
    .catch(error => console.log(error))
  }
  
  useEffect(() => getOtbData(), [])

  const getSeries = (data) => {    
    const series = []
    const colorsHash = {
      "0": "#ff5e5e",
      "500": "#edb126",
      "1501": "#5cc3ff",
      "2501": "#5dc95d",
      "3501": "#ff75a9",
      "4501": "#db8fff",
      "5501": "#24e3dc",
      "6501+": "#ffaa3b",
    }    
    
    let otbLength = data.map(({Data}) => Data.length)[0]
    
    for(let i = 0; i < otbLength; i++) {
      let obj = {}
      obj["name"] = data.map(({Data}) => Data[i].OTB_Range)[0]
      obj["data"] = data.map(({Data}) => Data[i].Qty)
      obj["color"] = colorsHash[obj.name.split("-")[0]]
      series.push(obj)      
    }
    
    return series    
  }

  const handleMetricChange = e => {
    const { value } = e.target
    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/otb/${value}?Source=${source}`, {headers: {token: token}})
  
    request.then((response => response.json()))
    .then((data => {    
      if(source < 1) {        
        setDataSourced(data)
        setDefaultData(data)
        setMetric(value)        
      } else {        
        let dataArr = []
        for(let i = 0; i < data.length; i++) {
          let dataObj = {}
          dataObj["Key"] = data[i].Key
          dataObj["Label"] = data[i].Label
          dataObj["ProfitCenter"] = data[i].ProfitCenter
          dataObj["StoreId"] = data[i].StoreID
          dataObj["Data"] = data[i].Source[source - 1].Data
          dataArr.push(dataObj)
        }

        setDataSourced(dataArr)
        setDefaultData(dataArr)
        setMetric(value)        
      }
    }))
  }

  const handleSourceChange = e => {    
    const { value } = e.target        
    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/otb/${metric}?source=${value}`, {headers: {token: token}})

    request.then((response => response.json()))
    .then(data => {      
      if(value === 0) {
        setDataSourced(data)
        setDefaultData(data)
        setSource(value)        
      } else {
        let dataArr = []
        for(let i = 0; i < data.length; i++) {
          let dataObj = {}
          dataObj["Key"] = data[i].Key
          dataObj["Label"] = data[i].Label
          dataObj["ProfitCenter"] = data[i].ProfitCenter
          dataObj["StoreId"] = data[i].StoreID
          dataObj["Data"] = data[i].Source[value - 1].Data
          dataArr.push(dataObj)
        }

        setDataSourced(dataArr)
        setDefaultData(dataArr)
        setSource(value)        
      }
    })
    .catch(error => console.log(error))
  }

  const handleLocationClick = location => {    
    setDataSourced(dataSourced.filter(({Label}) => Label === location))    
    setSelectedLocation(location)  
  }

  const handleOtbLocationReset = () => {
    setDataSourced(defaultData)    
    setSelectedLocation(null)
  }

  if(!otbData || !dataSourced) return <CircularProgress />
  if(!hasData) return <AskReport />
  
  return (
    <div id="otb-counts">      
      <PageHeader details={{icon: <ShoppingCartIcon style={{fontSize: "16px"}}/>, title: "OTB COUNTS"}}/>
      <br/>
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <Paper className={`chart ${dark ? "bg-dk" : "bg-lt"}`}>
          <div style={selectedLocation ? {} : {display: 'none'}}>
            <Button
              className="reset-btn"
              variant="outlined"
              onClick={handleOtbLocationReset}
              disableRipple
            >
              <ArrowBackIcon style={{fontSize: '15px'}} />
              <Typography style={{paddingTop: '2px', marginLeft: '2px'}} variant="caption">BACK TO ALL {metric.toUpperCase()}S</Typography>
            </Button>
          </div>
          <BarChartStacked
            labels={dataSourced.map(({Label}) => Label)}
            series={getSeries(dataSourced)}
            colors={getSeries(dataSourced).map(({color}) => color)}
            xLabel={'OTB Count'}              
            darkMode={dark}
            title={'OTB by Location'}
            handleLocationClick={handleLocationClick}
          />          
        </Paper>
        <div className="filter-table-group">
          <Paper className={`filter-paper ${dark ? "bg-dk" : "bg-lt"}`}>
            <FormControl variant="outlined"
              className="form-control"
              style={{marginTop: '30px'}}
              size="small"
            >
              <InputLabel style={ dark ? {color: "#fff", backgroundColor: "#6e6e6e"} : {color: "#6e6e6e"}} id="metric-select-label">Metric Type</InputLabel>
              <Select
                id="metric"
                labelId="metric-select-label"
                value={metric}
                onChange={handleMetricChange}
                label="Metric Type"
                style={dark ? {color: "#fff", border: '1px solid #fff'} : {}}
              >
                <MenuItem value={'location'}>Location</MenuItem>
                <MenuItem value={'market'}>Market</MenuItem>
              </Select>
            </FormControl>
            <FormControl variant="outlined" className="form-control" size="small">
              <InputLabel style={dark ? {color: "#fff", backgroundColor: "#6e6e6e", padding: "0 5px 0 5px"} : {color: "#6e6e6e"}}>Source</InputLabel>
              <Select
                value={source}
                onChange={handleSourceChange}
                label="Data Source"
                style={dark ? {color: "#fff", border: "1px solid #fff"} : {}}
              >
                <MenuItem value={0}>All</MenuItem>
                {otbData[0].Source.map(({Source_Key, Source_Name}) => (
                  <MenuItem key={Source_Key} value={Source_Key} name={Source_Name}>{Source_Name}</MenuItem>
                ))
                }
              </Select>
            </FormControl>
          </Paper>
          <Paper className={`table-border ${dark ? "bg-dk" : "bg-lt"}`}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" colSpan={2} component="th" scope="row">
                    <Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>QUANTITY BY OTB RANGE</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell><Typography variant="caption" style={{fontSize: 11, fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>OTB Range</Typography></TableCell>
                  <TableCell align="right" style={{borderLeft: "1px solid #b3b3b3"}}><Typography variant="caption" style={{fontSize: 11, fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>Quantity</Typography></TableCell>
                </TableRow>
                {getSeries(dataSourced).map(({name, color, data}) => (
                  <StyledTableRow key={name}>
                    <TableCell><Typography variant="caption" style={{color: `${color}`}}>{name}</Typography></TableCell>
                    <TableCell align="right" style={{borderLeft: "1px solid #b3b3b3"}}>
                      <Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{data.reduce((a,b) => a + b, 0).toLocaleString("en")}</Typography>
                    </TableCell>
                  </StyledTableRow>
                ))}
                <StyledTableRow>
                  <TableCell component="th" scope="row">
                    <Typography variant="caption" style={{fontWeight: 'bold', fontSize: 13, color: `${dark ? "#fff" : "#6e6e6e"}`}}>Total</Typography>
                  </TableCell>
                  <TableCell align="right" style={{borderLeft: "1px solid #b3b3b3"}}>
                    <Typography variant="caption" style={{fontWeight: 'bold', fontSize: 13, color: `${dark ? "#fff" : "#6e6e6e"}`}}>{getSeries(dataSourced).map(({data}) => data).map(item => item.reduce((a,b) => a + b, 0)).reduce((a,b) => a + b, 0).toLocaleString('en')}</Typography>
                  </TableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </Paper>
          <Paper className={`grand-total ${dark ? "bg-dk" : "bg-lt"}`}>
            <Typography style={{color: `${dark ? "#fff" : "#6e6e6e"}`}} display="block" variant="caption">
                The <span style={{fontWeight: 'bold'}}>Grand Total</span> OTB Count is
                <div className="total">{otbTotal.toLocaleString("en")}</div>
            </Typography>
          </Paper>
        </div>
      </div>
    </div>
  )  
}

export default OtbCounts
